export default __webpack_public_path__ + "static/media/n1.3.e0c4c134.jpg";